/**
 * 充值回链（billing loop）。
 *
 * Plan 的购买页接受 `return=<当前页面>`，付完 / 点「返回」时把用户送回 Studio 原页面。
 * 后端 `/api/me?return=` 已经做了白名单与编码，但 UsageDialog 拿到的 purchaseUrl
 * 是 `/api/me` **不带** return 的版本，所以打开前在客户端补一次：
 *   `...&return=<encodeURIComponent(location.href)>`
 *
 * 这里只负责拼串，不校验域名 —— 校验在服务端（`lib/billingUrl`），
 * 客户端把「当前页面」原样交出去即可。
 */
export function withBillingReturn(purchaseUrl: string, href: string): string {
  // 已经带 return（例如页面从 `/api/me?return=...` 拿过）就不要覆盖。
  if (/([?&])return=/.test(purchaseUrl)) return purchaseUrl;
  const separator = purchaseUrl.includes("?") ? "&" : "?";
  return `${purchaseUrl}${separator}return=${encodeURIComponent(href)}`;
}

/** 当前页面的绝对地址；SSR / 非浏览器环境返回空串。 */
export function currentPageHref(): string {
  return typeof window === "undefined" ? "" : window.location.href;
}

/** `location.search` 里是否有 `billing=1`（充值回来那一跳）。 */
export function hasBillingReturn(search: string): boolean {
  return new URLSearchParams(search).get("billing") === "1";
}

/** 去掉 `billing` 参数后的站内地址（保留 path / 其它 query / hash）。 */
export function stripBillingParam(pathname: string, search: string, hash: string): string {
  const params = new URLSearchParams(search);
  params.delete("billing");
  const next = params.toString();
  return `${pathname}${next ? `?${next}` : ""}${hash}`;
}
